import { Component } from '@angular/core';

@Component({
  selector: 'data-source-connect-status-info',
  templateUrl: './data-source-connect-status-info.html',
  styleUrl: './data-source-connect-status-info.scss',
  standalone: false,
})
export class DataSourceConectStatusInfoComponent {}
